import { render, staticRenderFns } from "./HeadlineElement.vue?vue&type=template&id=1c9f9ff4&scoped=true&"
import script from "./HeadlineElement.vue?vue&type=script&lang=js&"
export * from "./HeadlineElement.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineElement.vue?vue&type=style&index=0&id=1c9f9ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9f9ff4",
  null
  
)

export default component.exports